import * as React from 'react'

import { Box, type Colors, Icon, Text } from '@factorialco/deprecated-design-system'

export interface PublicProps {
  value: unknown
  label: string
  searchValue: string
  children: React.ReactNode | string
  isDisabled?: boolean
  isHidden?: boolean
}

export interface PrivateProps extends PublicProps {
  onChange: () => void
  isChecked: boolean
}

const Option: React.FC<PrivateProps> = ({
  children,
  onChange,
  isChecked,
  isDisabled = false,
  isHidden = false,
}) => {
  const [isHover, setIsHover] = React.useState<boolean>(false)

  if (isHidden) return null

  const getBgColor = (): Colors => {
    if (isChecked) return 'viridian100'
    if (isHover) return 'grey200'

    return 'grey000White'
  }

  return (
    <Box
      onClick={isDisabled ? null : onChange}
      alignItems="center"
      background={getBgColor()}
      cursor={isDisabled ? 'default' : 'pointer'}
      flexDirection="row"
      justifyContent="spaceBetween"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      paddingY="s16"
      paddingX="s16"
      width="full"
      style={{ maxHeight: '56px' }}
    >
      <Text.Normal
        size="300"
        weight="medium"
        ellipsis
        color={isChecked ? 'viridian1200' : 'grey800'}
      >
        {children}
      </Text.Normal>
      {isChecked && <Icon.Medium icon="check" color="viridian1200" />}
    </Box>
  )
}

export default Option
